<script>
import eventBus from '@refapp/eventbus-js';
import ServiceType from './tagging-service-type';
import EventsTracking from '../../../../shared/eventsTracking.js';

const PRODUCT_NAME_KEY = '[product name]';
const PRODUCT_ID_KEY = '[product id]';
const RETAILER_NAME_KEY = '[retailer name]';
const PAGE_CATEGORY_KEY = '[page category]';
const PRODUCT_SPU_KEY = '[product spu]';
const PRODUCT_CATEGORY_KEY = '[product category]';

/* eslint-disable eqeqeq */
export default {
  name: 'rfp-mctb-tags',
  data() {
    return {
      productName: '',
      productID: '',
      retailerName: '',
      extraParams: '',
      pageCategory: EventsTracking.globalVars[PAGE_CATEGORY_KEY],
    };
  },
  created() {
    eventBus.on('rfpTaggingFoundation', ({ data, values, extraParams, service }) => {
      if (!window.dataLayer && !window._gsq) return;
      const tags = this.createTags(data, values, extraParams);
      if (!tags) return;

      switch (service) {
        case ServiceType.GSQ:
          window._gsq.push(['track', data.EventName, tags]);
          break;
        // Intentional fallthrough
        case ServiceType.GA:
        default:
          window.dataLayer.push(tags);
      }
    });
  },
  methods: {
    createTags(data, values, extraParams) {
      if (!data || !values) return;
      const tags = {};
      let originalMsg = JSON.stringify(data);
      const productName = values.productName
        ?.replace(/<\/?[^>]+(>|$)/g, ' ')
        .replace(/\s\s+/g, ' ')
        .toLowerCase()
        .trim();
      const productTags = {
        [PRODUCT_NAME_KEY]: productName,
        [PRODUCT_ID_KEY]: values.productId?.toString(),
        [RETAILER_NAME_KEY]: values.retailerName?.toLowerCase(),
        [PAGE_CATEGORY_KEY]: (this.pageCategory || extraParams?.pageCategory)?.toLowerCase(),
        [PRODUCT_SPU_KEY]: extraParams?.productSpu?.toLowerCase(),
        [PRODUCT_CATEGORY_KEY]: extraParams?.productCategory?.toLowerCase(),
      };
      Object.entries(productTags).forEach(([productKey, productValue]) => {
        if (!originalMsg.includes(productKey)) return;
        originalMsg = originalMsg.replaceAll(productKey, productValue || '');
      });
      originalMsg = originalMsg.replaceAll('::::', '::');
      for (const [key, value] of Object.entries(JSON.parse(originalMsg.replaceAll('\n', '\\n')))) {
        tags[`${key}`] =
          value === '[more information]' ? window.refapp?.mctbEcommerce || '' : value;
      }
      return tags;
    },
  },
  render() {
    const isVue3Slot = this.$slots.default instanceof Function;

    if (isVue3Slot) {
      return this.$slots.default();
    }

    return this.$slots.default;
  },
};
</script>
